var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.111084C10.1787 0.111084 11.3092 0.579336 12.1427 1.41283C12.9762 2.24633 13.4444 3.37679 13.4444 4.55553C13.4444 5.73427 12.9762 6.86473 12.1427 7.69823C11.3092 8.53172 10.1787 8.99997 9 8.99997C7.82126 8.99997 6.6908 8.53172 5.85731 7.69823C5.02381 6.86473 4.55556 5.73427 4.55556 4.55553C4.55556 3.37679 5.02381 2.24633 5.85731 1.41283C6.6908 0.579336 7.82126 0.111084 9 0.111084ZM9 11.2222C13.9111 11.2222 17.8889 13.2111 17.8889 15.6666V17.8889H0.111115V15.6666C0.111115 13.2111 4.08889 11.2222 9 11.2222Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2edaf608bc420f94864ddbe529ba5739.svg";
export { ForwardRef as ReactComponent };